import http from "../http";

const RolesService = {
    getRolesService: async () => {
        const roles = await http.instance.get("/roles");
        return roles.data
    },
    getRolesOfProjectsService: async (payload) => {
        const rolesofproject = await http.instance.get("/roles/rolesofproject/" + payload);
        return rolesofproject.data;
    },
    getUserProjectRoles: async (userId, projectId) => {
        const userprojectroles = await http.instance.get("/roles/userrolesofproject/" + userId + "/" + projectId);
        return userprojectroles.data;
    },
    getUserRoles: async (id) => {
        const userroles = await http.instance.get("/roles/usersofrole/" + id);
        return userroles.data;
    },
    getPermissionsByProjectService: async (payload) => {
        const permissions = await http.instance.get("roles/projectpermissions/" + payload);
        return permissions.data;
    },
    getPermissionsService: async () => {
        const permissions = await http.instance.get("roles/permissions/");
        return permissions.data;
    },

    getRolePermissions: async (payload) => {
        const rolepermissions = await http.instance.get("roles/rolepermissionsproject/" + payload);
        return rolepermissions.data;
    },
    addRoleService: async (form) => {
        const addrole = await http.instance.post("/roles/addrole", form);
        return addrole.data;
    },
    addGroupService: async (form) => {
        const addgroup = await http.instance.post("/roles/addgroup", form);
        return addgroup.data;
    },
    addUserRoleService: async (userId, roleId) => {
        const userrole = await http.instance.post("/roles/adduserrole?" + "userId=" + userId + "&roleId=" + roleId);
        return userrole.data;
    },
    addPermissionService: async (form) => {
        const addp = await http.instance.post("roles/addpermission", form);
        return addp.data;
    },
    addRolePermission: async (form) => {
        const rp = await http.instance.post("roles/addrolepermission", form)
        return rp.data;
    },
    deleteRoleService: async (payload) => {
        const deleterole = await http.instance.post("/roles/deleterole/" + payload);
        return deleterole.data;
    },
    deleteRolePermissionService: async (payload) => {
        const deleterolepermission = await http.instance.post("/roles/deleterolepermission/" + payload);
        return deleterolepermission.data;
    },
    deleteUserRoleService: async (payload) => {
        const deleteuserrole = await http.instance.post("/roles/deleteuserrole/" + payload);
        return deleteuserrole.data;
    },

};
export default RolesService;
